<div class="blogs">
  <app-page-header
    searchPlaceholder="Search by title..."
    (searchEvent)="handleSearch($event)"
    [pageTitle]="'Blog'"
    [numberOfItem]="totalBlog"
    [loading]="
      blogListLoading && (blogFilter | async)?.pageNumber === 1 && !totalBlog
    "
  >
    <form [formGroup]="categoryForm">
      <app-multiselect-dropdown
        [multiselect]="false"
        [searchable]="false"
        [pagination]="false"
        [config]="categoryDropdownSettings"
        [options]="categoryOptions"
        [control]="categoryForm.get('category')"
      ></app-multiselect-dropdown>
    </form>

    <button class="button" [routerLink]="['/add-blog']" addButton>
      <img src="assets/images/add.svg" alt="+" />
      Add <span>Blog</span>
    </button></app-page-header
  >

  <ng-container *ngIf="deleteBlogId">
    <app-confirmation-modal
      primaryButtonText="Cancel"
      secondaryButtonText="Yes"
      message="Are you sure you want to delete this blog ?"
      caption="Delete Confirmation"
      (onPrimaryButtonClick)="cancelDelete()"
      (onSecondaryButtonClick)="deleteBlog()"
      [secondaryButtonLoading]="deleteLoading"
    ></app-confirmation-modal>
  </ng-container>

  <ng-container
    *ngIf="
      blogListLoading && (blogFilter | async)?.pageNumber === 1;
      else blogs
    "
  >
    <div class="blogs__list flex-wrap">
      <div class="blogs__item" *ngFor="let i of [].constructor(6)">
        <div class="blogs__card">
          <app-skeleton [ratio]="1 / 1" margin="0 0 10px"></app-skeleton>
          <app-skeleton
            height="15px"
            width="80%"
            margin="0 0 3px"
          ></app-skeleton>
          <app-skeleton height="10px" width="90%"></app-skeleton>
          <app-skeleton
            height="10px"
            width="70%"
            margin="0 0 8px"
          ></app-skeleton>
          <div>
            <app-skeleton height="10px" width="100px"></app-skeleton>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #blogs>
    <ng-container *ngIf="blogList.length > 0; else noDataFound"></ng-container>
    <div class="blogs__list flex-wrap">
      <div
        class="blogs__item flex"
        *ngFor="let blog of blogList; let i = index"
      >
        <app-blog
          class="flex"
          [blog]="blog"
          [index]="i"
          [lastElement]="blogList.length === i + 1"
          [menuOpenIndex]="menuOpenIndex"
          (closeMenuEmitter)="closeAllMenu(i)"
          (openMenuEmitter)="openMenu(i)"
          (onDeleteBlogEmitter)="onDeleteBlog($event)"
          (loadMoreIfLastIndexEmitter)="loadMoreIfLastIndex()"
        ></app-blog>
      </div>
    </div>
    <div *ngIf="blogListLoading">
      <div class="blogs__list flex-wrap">
        <div class="blogs__item" *ngFor="let i of [].constructor(6)">
          <div class="blogs__card">
            <app-skeleton [ratio]="1 / 1" margin="0 0 10px"></app-skeleton>
            <app-skeleton
              height="15px"
              width="80%"
              margin="0 0 3px"
            ></app-skeleton>
            <app-skeleton height="10px" width="90%"></app-skeleton>
            <app-skeleton
              height="10px"
              width="70%"
              margin="0 0 8px"
            ></app-skeleton>
            <div>
              <app-skeleton height="10px" width="100px"></app-skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #noDataFound>
    <div class="blogs__nodata">
      <p>No data found</p>
    </div>
  </ng-template>
</div>
